export default __webpack_public_path__ + "static/media/Simcard_charge.720ef9dc.png";